<!--
 * @Descripttion: 
 * @Author: Rul
 * @Date: 2020-04-01 14:40:11
 * @LastEditors: Rul
 * @LastEditTime: 2020-04-21 19:20:18
 -->
<template>
  <div class="popup-act">
    <div class="btn-close" @click="$emit('close')"></div>
    <div>
      <img :src="info.img" @click="clickFloatPic">
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { jumpPage, toParam } from '@/utils/mUtil'
import { loginMixin } from '@/utils/mixin'

export default {
  mixins: [loginMixin],
  props: {
    info: {
      type: Object,
      default: null,
    },
  },
  methods: {
    clickHidePopupAct() {},
    // 点击右下角浮层图标跳转
    clickFloatPic() {
      Report.click({
        value: '{"evt": "5001"}',
      })

      // $.get(this.layerCreditsConf.click[0])

      let url = this.info.landing

      if (url.indexOf('imgotv') > -1) {
        location.href = url
      } else {
        jumpPage(url)
      }
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
}
</script>

<style lang="less">
.popup-act {
  position: fixed;
  right: 0.26666667rem;
  bottom: 0.53333333rem;
  z-index: 1;

  .btn-close {
    width: 0.42666667rem;
    height: 0.42666667rem;
    background-image: url('../../../assets/icon-close-act.png');
    background-size: 100% 100%;
    float: right;
  }

  img {
    width: 1.86666667rem;
  }
}
</style>
